module.exports = __webpack_public_path__ + "images/8989215c094e9f6bc7440c1f9fb14447.jpg";


//////////////////
// WEBPACK FOOTER
// ./webpack/assets/img/wheels-characters03.jpg
// module id = ./webpack/assets/img/wheels-characters03.jpg
// module chunks = 0